export const SUPPLIER_ARTICLE_PROMPT = 'supplierArticlePrompt';
